// App.js

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import RoomSelection from "./pages/RoomSelection";
import ChatRoomPage from "./pages/ChatRoomPage";
import LoginForm from "./components/LoginForm";
import RegisterForm from "./components/RegisterForm";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/rooms" element={<RoomSelection />} />
        <Route path="/chat/:roomName" element={<ChatRoomPage />} />
        <Route path="/login" element={<LoginForm />} />
        <Route path="/register" element={<RegisterForm />} />
      </Routes>
    </Router>
  );
}

export default App;
